import { Card, Flex, Rate, Row, Space, Typography } from "antd"
import PropTypes from "prop-types"
import { Icon } from "ui/Icon"
import { useState } from "react"
import PreviewModeModal from "ui/PreviewModeModal"

const { Title, Text, Paragraph } = Typography

export const PreviewGuide = ({ trip, t, embedded }) => {

  const { guide } = trip
  const [previewModal, setPreviewModal] = useState()
  return (
    <div style={{ marginTop: embedded ? 20 : 45 }}>
      <div style={{ marginBottom: embedded ? 20 : 40 }}>
        <Title className="pb-4" level={embedded ? 4 : 3}>
          {t("listings.tabs.preview.guided_by")}
        </Title>
        <Card className="" style={{ backgroundColor: "#F9FBFB" }}>
          <Row align="middle" justify="space-between">
            <Space size="large" align="center">
              <img
                src={guide?.avatar}
                alt="Guide"
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  objectFit: "cover"
                }}
              />
              <Space direction="vertical" size={0} style={{ gap: "8px" }}>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {guide?.display_name}
                </Title>
                <Text type="secondary">1 experience</Text>
                <div>
                  <Rate disabled allowHalf defaultValue={guide?.rating} />
                  <Text style={{ marginLeft: 8 }}>({guide?.rating})</Text>
                </div>
              </Space>
            </Space>
            {!embedded && (
              <div style={{ backgroundColor: "#FFFFFF", padding: "16px" }}>
                <Text style={{ fontWeight: "bold" }}>CONTACT ME</Text>
                <Flex gap={10} align="center" style={{ marginTop: "8px" }}>
                  <Icon type="feather" name="Phone" height={16} width={16} />
                  <a href={`tel:${guide?.phone_number}`} style={{ color: "#272A34", textDecoration: "none" }}>
                    {guide?.phone_number}
                  </a>
                </Flex>
                <Flex gap={10} align="center">
                  <Icon type="feather" name="Mail" height={16} width={16} />
                  <a href={`mailto:${guide?.email}`} style={{ color: "#272A34", textDecoration: "none" }}>
                    {guide?.email}
                  </a>
                </Flex>
              </div>
            )}
          </Row>
          <Row>
            <Paragraph style={{ marginTop: 16 }}>{guide?.description}</Paragraph>
          </Row>
        </Card>
      </div>
      <div>
        <Title className="pb-4" level={embedded ? 4 : 3}>
          {t("listings.tabs.preview.cancellation_policy")}
        </Title>
        <Text>
          {t("listings.tabs.preview.cancellation_desc") + " "}
          <a href="/#/cancellation-policy" target="_blank" rel="noopener noreferrer">
            {t("listings.tabs.preview.cancellation_policy")}
          </a>
        </Text>
      </div>
      <PreviewModeModal
        open={previewModal}
        onClose={() => {
          setPreviewModal(false)
        }}
      />
    </div>
  )
}

// ✅ PropTypes validation
PreviewGuide.propTypes = {
  trip: PropTypes.shape({
    guide: PropTypes.shape({
      avatar: PropTypes.string,
      display_name: PropTypes.string,
      rating: PropTypes.number,
      description: PropTypes.string,
      slug: PropTypes.string,
      email: PropTypes.string,
      phone_number: PropTypes.string
    })
  }).isRequired,
  t: PropTypes.func.isRequired,
  embedded: PropTypes.bool
}
